import { render, staticRenderFns } from "./sicknesscategorydetails.vue?vue&type=template&id=6db20ffa&scoped=true"
import script from "./sicknesscategorydetails.vue?vue&type=script&lang=js"
export * from "./sicknesscategorydetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db20ffa",
  null
  
)

export default component.exports